import { AppRemixIcon } from '@/layout/AppComponents';
import ReactDOMServer from 'react-dom/server';
import colors from '../../../../../../../constants/colors';
import Translator from '../../../../../../components/helpers/Translator';

export default function ChildrenTask(props) {
  const { hasChildren, onClick } = props;

  return (
    <span
      title={ReactDOMServer.renderToString(
        <Translator
          file="module-correctiveActions"
          name={hasChildren ? 'has.dependent.tasks' : 'has.not.dependent.tasks'}
        />
      )}
      className={hasChildren ? 'pointer' : ''}
      onClick={() => (hasChildren ? onClick() : undefined)}
    >
      <AppRemixIcon
        icon="git-merge"
        color={hasChildren ? colors.primary : colors.grey300}
      />
    </span>
  );
}
